module.exports = __webpack_public_path__ + "static/media/send-back.8d8fb9e4.svg";